import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

// ایجاد نمونه axios با تنظیمات پایه
const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

// اضافه کردن interceptor برای headers
api.interceptors.request.use(
  (config) => {
    const token = cookies.get("jwt-auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // برای درخواست‌های multipart/form-data
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// تابع کمکی برای مدیریت خطاها
const handleError = (error) => {
  if (!error.response) {
    return {
      status: "network_error",
      message: "لطفا اتصال اینترنت خود را بررسی کنید",
    };
  }
  return error.response;
};

export const deleteTag = async (deleteId) => {
  try {
    const response = await api.delete(`/articlesTag/${deleteId}`);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const getAllArticlesTag = async () => {
  try {
    const response = await api.get("/articlesTag/all");
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const createArticlesTag = async (data) => {
  try {
    const response = await api.post("/articlesTag/create", data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const updateArticlesTag = async ({ id, data }) => {
  try {
    const response = await api.post("/articlesTag/" + id, data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};
